"use strict";
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
// Remove ExemptEuropeanEconomicArea, FreeExportTaxNotCharged and ReverseCharged from AvailableTaxCategoryTypeEnum
var mapi_1 = require("@unimaze/api-clients/lib/mapi");
var ExemptEuropeanEconomicArea = mapi_1.TaxCategoryTypeEnum.ExemptEuropeanEconomicArea, FreeExportTaxNotCharged = mapi_1.TaxCategoryTypeEnum.FreeExportTaxNotCharged, ReverseCharged = mapi_1.TaxCategoryTypeEnum.ReverseCharged, AvailableTaxCategoryTypeEnum = __rest(mapi_1.TaxCategoryTypeEnum, ["ExemptEuropeanEconomicArea", "FreeExportTaxNotCharged", "ReverseCharged"]);
exports.AvailableTaxCategoryTypeEnum = AvailableTaxCategoryTypeEnum;
